import type { DocForLinking } from '../store/selectors/linking/docForLinkingType';
import type { DocsForLinkingIndex } from '../store/selectors/linking/docsForLinkingIndexType';

// Bevisst uten verdi-import fra store: modulen tar imot en ferdig indeks i
// stedet for å hente fra state, slik at den kan brukes (og testes) frittstående.

function convertInternalLink(
  a: globalThis.HTMLAnchorElement,
  doc: DocForLinking | undefined,
): globalThis.HTMLAnchorElement {
  if (doc) {
    if (doc.classified) {
      a.classList.add('classified');
    } else {
      a.classList.remove('classified');
    }
    if (doc.classes) {
      doc.classes.split(' ').forEach((c) => a.classList.add(c));
    }
    if (doc.noAccess) {
      a.setAttribute('href', 'restricted');
    } else {
      a.setAttribute('href', doc.href);
    }
    a.setAttribute('target', '_self');
    a.innerHTML = doc.name;
  } else {
    a.setAttribute('href', '');
    a.innerHTML = 'Finner ikke dokumentet: ' + a.innerHTML;
  }
  return a;
}

export function convertInternalLinks(string: string, docsIndex: DocsForLinkingIndex): string {
  const perfStart = performance.now();

  const doc = new DOMParser().parseFromString('<div id="temp">' + string + '</div>', 'text/html');
  const elm = doc.getElementById('temp') as HTMLElement;
  const anchors = elm.getElementsByTagName('a');
  for (let a of anchors) {
    let id = a.getAttribute('data-internal-link-id');
    if (!id) {
      a.classList.forEach((c) => {
        if (c.includes('internal-link-')) {
          id = c.replace('internal-link-', '');
          a.setAttribute('data-internal-link-id', id);
          a.classList.remove('internal', 'internal-link-' + id);
        }
      });
    }
    if (id) {
      // O(1) lookup using Map instead of O(n) array.find()
      const doc: DocForLinking | undefined = !isNaN(Number(id))
        ? docsIndex.byTemplateId.get(Number(id))
        : docsIndex.byUuid.get(id);
      a = convertInternalLink(a, doc);
    }
  }

  const perfEnd = performance.now();
  if (perfEnd - perfStart > 10) {
    console.warn('[Performance] convertInternalLinks took', (perfEnd - perfStart).toFixed(2), 'ms');
  }

  return elm.innerHTML;
}
export type { DocForLinking } from '../store/selectors/linking/docForLinkingType';
